import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-internal-user-details',
    templateUrl: './internal-user-details.component.html',
    styleUrls: ['./internal-user-details.component.scss'],
    standalone: false
})
export class InternalUserDetailsComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  userId!: string;

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => this.userId = params.uid);
  }
}
